package de.xtl.retroguide.question.scenes

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.spring
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import de.xtl.retroguide.protocol.AnswerCategory
import de.xtl.retroguide.question.accentColor
import de.xtl.retroguide.question.label

/** Pill with emoji, label and answer count that pops in whenever the count changes. */
@Composable
internal fun SceneBadge(category: AnswerCategory, count: Int, modifier: Modifier = Modifier) {
    val scale = remember { Animatable(0f) }
    LaunchedEffect(count) {
        scale.snapTo(.6f)
        scale.animateTo(1f, spring(dampingRatio = Spring.DampingRatioMediumBouncy, stiffness = Spring.StiffnessMedium))
    }
    Surface(
        shape = RoundedCornerShape(50),
        color = MaterialTheme.colorScheme.surface.copy(alpha = .92f),
        shadowElevation = 2.dp,
        modifier = modifier.graphicsLayer {
            scaleX = scale.value
            scaleY = scale.value
        },
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 10.dp, vertical = 6.dp),
            horizontalArrangement = Arrangement.spacedBy(6.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(category.emoji)
            Text(category.label(), style = MaterialTheme.typography.labelLarge)
            Text(
                count.toString(),
                style = MaterialTheme.typography.labelLarge,
                fontWeight = FontWeight.Bold,
                color = category.accentColor,
            )
        }
    }
}

@Composable
internal fun BoxScope.SceneCornerBadges(
    topStart: AnswerCategory,
    topEnd: AnswerCategory,
    bottomStart: AnswerCategory,
    bottomEnd: AnswerCategory,
    counts: Map<AnswerCategory, Int>,
) {
    SceneBadge(topStart, counts[topStart] ?: 0, Modifier.align(Alignment.TopStart).padding(12.dp))
    SceneBadge(topEnd, counts[topEnd] ?: 0, Modifier.align(Alignment.TopEnd).padding(12.dp))
    SceneBadge(bottomStart, counts[bottomStart] ?: 0, Modifier.align(Alignment.BottomStart).padding(12.dp))
    SceneBadge(bottomEnd, counts[bottomEnd] ?: 0, Modifier.align(Alignment.BottomEnd).padding(12.dp))
}
